.dropdownMenuContent:global(.rt-DropdownMenuContent) {
  background: var(--slate-5);

  :global(.rt-DropdownMenuItem) {
    height: unset;
  }

  /* SubTrigger always appends Radix chevron; we use FlySvgSprite instead. */
  :global(.rt-DropdownMenuSubTrigger) > :global(.rt-DropdownMenuShortcut) {
    display: none;
  }
}

.dropdownMenuContent:global(.rt-DropdownMenuSubContent) {
  margin-left: -10px;
}
